//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapState, mapGetters, mapActions } from 'vuex';
import User from '~/components/User.vue';
import Filters from './ReferralProgramLeadsFilters.vue';
import constant from '~/const';
import GetReport from '~/components/GetReport.vue';
import ReferralProgramExtra from './ReferralProgramExtra.vue';

import tableConfig from './tableConfig';

export default {
  components: {
    Filters,
    User,
    GetReport,
    ReferralProgramExtra,
  },

  data() {
    return {
      tableConfig,
      selection: [],
      constant,
      loader: false,
    };
  },

  computed: {
    ...mapState('common', ['generalLoader']),
    ...mapGetters('common', ['itemsPerPage']),

    ...mapState('referralsLeads', ['page', 'pages', 'leads', 'sort']),
    ...mapGetters('referralsLeads', ['requestData']),

    getLeads() {
      return this.leads.map((__, index) => {
        return {
          id: index + 1,
          ...this.leads[index],
        };
      });
    },
  },

  methods: {
    ...mapActions('common', ['setGeneralLoader', 'setSuccessNotification', 'setGeneralProgress']),
    ...mapActions('referralsLeads', {
      loadDataAction: 'loadLeads',
      setPageAction: 'setPage',
      setSortAction: 'setSort',
    }),

    applySort(data) {
      this.setSortAction(data);
      this.loadData();
    },

    async loadData(data = {}) {
      this.setGeneralProgress(true);
      await this.loadDataAction(data);
      this.setGeneralProgress(false);
    },

    applyFilters() {
      this.loadData();
    },

    setPage(value) {
      this.setPageAction(value);

      const extendedRequestData = {
        getTotal: false,
      };

      this.loadData(extendedRequestData);
    },

    actionHandler({ action, payload }) {
      this[action](payload);
    },
  },
};
